import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { castDraft } from 'immer';

import { ProductionComponentInstance } from '@paragon/contract-library';

import { productionGroupDeleted } from './productionGroupsSlice';

export interface ProductionComponentInstancesState {
  [guid: string]: ProductionComponentInstance;
}

const initialState: ProductionComponentInstancesState = {};

const productionComponentInstancesSlice = createSlice({
  name: 'productionComponentInstances',
  initialState,
  reducers: {
    productionComponentInstancesLoaded: (state, action: PayloadAction<readonly ProductionComponentInstance[]>) => {
      for (const productionComponentInstance of action.payload) {
        state[productionComponentInstance.guid] = castDraft(productionComponentInstance);
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(productionGroupDeleted, (state, action) => {
      for (const [batchGuid, batch] of Object.entries(state)) {
        if (batch.productionGroupGuid === action.payload) {
          delete state[batchGuid];
        }
      }
    });
  },
});

export const { productionComponentInstancesLoaded } = productionComponentInstancesSlice.actions;
export const productionComponentInstances = productionComponentInstancesSlice.reducer;
